import { render, staticRenderFns } from "./activelist.vue?vue&type=template&id=1dd6af32&scoped=true&"
import script from "./activelist.vue?vue&type=script&lang=js&"
export * from "./activelist.vue?vue&type=script&lang=js&"
import style0 from "./activelist.vue?vue&type=style&index=0&id=1dd6af32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6af32",
  null
  
)

export default component.exports